/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { bool, func, object } from 'prop-types';
import { useQuery } from '@apollo/client';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import mbpLogger from '@module-logger/mbp';
import findContent from '../../../gql/queries/findContent';

const findContentOptions = {
    brand: 'global',
    contentType: 'subscriptions_global_copy',
};
const GET_CANCEL_SUBSCRIPTION_CONTENT = findContent(findContentOptions);

const styles = (theme) => ({
    dialogContent: {
        fontSize: '.8em',
        textWrap: 'pretty',
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },
    popUpHeading: {
        textAlign: 'center',
        '& span': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
});

const CancelSubscriptionModal = ({ open, setSubscriptionCancelModalOpen, classes }) => {
    const { data, loading, error } = useQuery(GET_CANCEL_SUBSCRIPTION_CONTENT);

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: 'Failed to fetch cancellation subscription content.',
        });
    }
    if (!data || loading) {
        return null;
    }
    const cancelationCopy = 'You may cancel your subscription at any time before your next order is processed. Refunds will not be provided for any orders that have already been processed prior to receipt of your cancellation request. To cancel your subscription, log into your Company account, navigate to the subscriptions page in your account, and click “Cancel Subscription”.  You may also cancel your subscription by emailing us at [info@1800flower-usa.com](mailto:info@1800flower-usa.com) or calling us at 888-471-2090.';
    const cancellationData = data?.findContent?.content?.entries?.[0]?.cancel_modal_copy || {};
    const title = cancellationData?.modal_title || 'How to Cancel a Subscription';
    const copy = cancellationData?.model_copy || cancelationCopy;
    return (
        <Dialog data-testid="cancel-subscription-modal" open={open} onClose={() => setSubscriptionCancelModalOpen(false)}>
            <DialogTitle className={classes.popUpHeading} id="cancel-subscription-modal-title">
                <span>{title}</span>
                <IconButton className={classes.closeBtn} aria-label="Close" onClick={() => setSubscriptionCancelModalOpen(false)}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography gutterBottom className={classes.dialogContent}>
                    <ReactMarkdown source={copy} escapeHtml={false} />
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

CancelSubscriptionModal.propTypes = {
    open: bool.isRequired,
    setSubscriptionCancelModalOpen: func.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(CancelSubscriptionModal);
